<form *ngIf="location" name="deleteForm" (ngSubmit)="confirmDelete(location.id!)">
  <div class="modal-header">
    <h4 class="modal-title" data-cy="locationDeleteDialogHeading">Confirmation de suppression</h4>
  </div>

  <div class="modal-body">
    <p id="delete-location-heading">
      Etes-vous certain de vouloir supprimer ce lieu ?
    </p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">
      <span>Annuler</span>
    </button>

    <button id="confirm-delete-location" data-cy="entityConfirmDeleteButton" type="submit" class="btn btn-danger">
      <span>Supprimer</span>
    </button>
  </div>
</form>
